/** @module Enums */ /** typedoc */

/**
 * dollar-sign currencies country codes (http://www.xe.com/symbols.php#section3)
 * - ARS: Argentina Peso
 * - AUD: Australia Dollar
 * - BSD: Bahamas Dollar
 * - BBD: Barbados Dollar
 * - BMD: Bermuda Dollar
 * - BND: Brunei Darussalam Dollar
 * - CAD: Canada Dollar
 * - KYD: Cayman Islands Dollar
 * - CLP: Chile Peso
 * - COP: Colombia Peso
 * - XCD: East Caribbean Dollar
 * - SVC: El Salvador Colon
 * - FJD: Fiji Dollar
 * - GYD: Guyana Dollar
 * - HKD: Hong Kong Dollar
 * - LRD: Liberia Dollar
 * - MXN: Mexico Peso
 * - NAD: Namibia Dollar
 * - NZD: New Zealand Dollar
 * - SGD: Singapore Dollar
 * - SBD: Solomon Islands Dollar
 * - SRD: Suriname Dollar
 * - TVD: Tuvalu Dollar
 * - USD: United States Dollar
 */
export enum DollarSignCurrenciesEnum {
    ARS = 'ARS',
    AUD = 'AUD',
    BSD = 'BSD',
    BBD = 'BBD',
    BMD = 'BMD',
    BND = 'BND',
    CAD = 'CAD',
    KYD = 'KYD',
    CLP = 'CLP',
    COP = 'COP',
    XCD = 'XCD',
    SVC = 'SVC',
    FJD = 'FJD',
    GYD = 'GYD',
    HKD = 'HKD',
    LRD = 'LRD',
    MXN = 'MXN',
    NAD = 'NAD',
    NZD = 'NZD',
    SGD = 'SGD',
    SBD = 'SBD',
    SRD = 'SRD',
    TVD = 'TVD',
    USD = 'USD'
}
